import { render, staticRenderFns } from "./dateValue.vue?vue&type=template&id=c8657064"
import script from "./dateValue.vue?vue&type=script&lang=ts"
export * from "./dateValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports